module.exports = __webpack_public_path__ + "static/img/v30_05.b01def1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/v30_05.jpg
// module id = Zvjq
// module chunks = 3